import React from 'react';
import { SurveyQuestionText, CharacterCounterComponent } from 'survey-react-ui';

import { Input } from '../../../../components/atoms/input/input';

const registerTextInputOverride = (props: unknown): React.JSX.Element => {
  return React.createElement(TextInputOverride, props);
};

const stringOrEmpty = (string: string) => string ?? '';

class TextInputOverride extends SurveyQuestionText {
  getInputProps() {
    const q = this.question;
    return {
      'aria-describedby': q.a11y_input_ariaDescribedBy,
      'aria-errormessage': q.a11y_input_ariaErrormessage,
      'aria-invalid': q.a11y_input_ariaInvalid,
      'aria-label': q.a11y_input_ariaLabel,
      'aria-labelledby': q.a11y_input_ariaLabelledBy,
      'aria-required': q.a11y_input_ariaRequired,
      autoComplete: q.autoComplete,
      disabled: q.isDisabledAttr,
      id: q.inputId,
      inputMode: q.inputMode,
      maxLength: q.getMaxLength?.() ?? q.maxLength,
      minLength: q.minLength,
      name: q.name,
      onBlur: (event: React.FocusEvent<HTMLInputElement>) => q.onBlur(event),
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        q.inputValue = e.target.value;
        q.onChange(e);
      },
      onClick: q.readOnlyBlocker,
      onCompositionUpdate: (event: React.CompositionEvent<HTMLInputElement>) =>
        q.onCompositionUpdate(event.nativeEvent),
      onFocus: (event: React.FocusEvent<HTMLInputElement>) => q.onFocus(event),
      onKeyDown: q.onKeyDown,
      onKeyUp: q.onKeyUp,
      onPointerDown: q.readOnlyBlocker,
      pattern: q.pattern,
      placeholder: stringOrEmpty(q.renderedPlaceholder),
      readOnly: q.isInputReadOnly,
      ref: (input: HTMLInputElement | null) => this.setControl(input),
      required: q.isRequired,
      spellCheck: q.spellCheck,
      tabIndex: q.inputTabIndex,
      type: q.inputType || 'text',
      value: stringOrEmpty(q.inputValue),
    };
  }

  override renderInput(): React.JSX.Element {
    if (this.question.isReadOnlyRenderDiv()) {
      return <div>{this.question.inputValue}</div>;
    }

    const counter = this.question.getMaxLength() ? (
      <CharacterCounterComponent
        counter={this.question.characterCounter}
        remainingCharacterCounter={this.question.cssClasses.remainingCharacterCounter}
      ></CharacterCounterComponent>
    ) : null;

    return (
      <>
        <Input {...this.getInputProps()} />
        {counter}
      </>
    );
  }
}

export { registerTextInputOverride, stringOrEmpty, TextInputOverride };
